var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogIcon01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6984 4.88751L10.1121 1.30126C9.36005 0.549175 8.32297 0.145425 7.26213 0.200842L3.3038 0.390842C1.72047 0.462092 0.461718 1.72084 0.382551 3.29626L0.192551 7.25459C0.145051 8.31542 0.540884 9.35251 1.29297 10.1046L4.87922 13.6908C6.35172 15.1633 8.74255 15.1633 10.223 13.6908L13.6984 10.2154C15.1788 8.75084 15.1788 6.36001 13.6984 4.88751ZM5.52047 7.80084C4.26963 7.80084 3.24047 6.77959 3.24047 5.52084C3.24047 4.26209 4.26963 3.24084 5.52047 3.24084C6.7713 3.24084 7.80047 4.26209 7.80047 5.52084C7.80047 6.77959 6.7713 7.80084 5.52047 7.80084ZM11.8776 8.71126L8.71088 11.8779C8.59213 11.9967 8.44172 12.0521 8.2913 12.0521C8.14088 12.0521 7.99047 11.9967 7.87172 11.8779C7.64213 11.6483 7.64213 11.2683 7.87172 11.0388L11.0384 7.87209C11.268 7.64251 11.648 7.64251 11.8776 7.87209C12.1071 8.10168 12.1071 8.48167 11.8776 8.71126Z",
    fill: "url(#paint0_linear_orange)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_orange",
    x1: -0.799823,
    y1: 12.3542,
    x2: 14.8183,
    y2: 0.181632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF6A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogIcon01);
export default __webpack_public_path__ + "static/media/blog-icon01.6129bc90423089d362178c3c41fd8029.svg";
export { ForwardRef as ReactComponent };